<div>
    <ion-searchbar #search *ngIf="showSearchBar" [value]="value" [placeholder]="placeholder" [disabled]="disabled" debounce="800" mode="ios" [showCancelButton]="'never'" [showClearButton]="clearButtonMode"
        (ionInput)="onSearchInput($event)"
        (ionFocus)="onSearchFocus()"
        (ionBlur)="onSearchBlur($event)"
        (ionClear)="onSearchClear()">
    </ion-searchbar>
    <ion-icon *ngIf="!showSearchBar"
        tooltip={{placeholder}} placement="left" name="search-outline" class="grow" [class.search-disabled]="disabled"
        [attr.tabindex]="disabled ? -1 : 0" role="button" [attr.aria-label]="placeholder" [attr.aria-disabled]="disabled"
        (click)="showSearchBarIcon()"
        (keydown.enter)="showSearchBarIcon()"
        (keydown.space)="$event.preventDefault(); showSearchBarIcon()">
    </ion-icon>
</div>